import Loading from "components/Loading"
import React from "react"
import { useDownloadMessageMedia } from "requests/tanstack/useDownloadMessageMedia"

type Props = {
    videoUrl: string
}

export default function VideoPlayer(props: Props) {
    const { videoUrl } = props
    const { data: videoBlobData, isLoading: videoLoading, error: videoFetchError } = useDownloadMessageMedia(videoUrl)

    if (videoLoading || !videoBlobData) return <Loading />
    if (videoFetchError) return <p style={{ color: "red" }}>Erro ao carregar vídeo</p>

    return (
        <video controls src={videoBlobData.url} style={{ width: '100%', maxWidth: "250px" }}>
            <source src={videoBlobData.url} type={videoBlobData.type} />
        </video>
    )
}
